import { render } from "./MetaData.vue?vue&type=template&id=20dd23ba"
import script from "./MetaData.vue?vue&type=script&lang=js"
export * from "./MetaData.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "20dd23ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20dd23ba', script)) {
    api.reload('20dd23ba', script)
  }
  
  module.hot.accept("./MetaData.vue?vue&type=template&id=20dd23ba", () => {
    api.rerender('20dd23ba', render)
  })

}

script.__file = "resources/js/Pages/Media/MetaData.vue"

export default script